import baseUrl from "../config/baseUrl";

const sendDocLinkSMS = async ({ token, phone, doc_link }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/send_doc_link_sms?doc_link=${doc_link}&phone=${phone}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default sendDocLinkSMS;
